// extracted by mini-css-extract-plugin
export default {"bannerBg":"about_bannerBg__VQ7J3","bannerBgColor":"about_bannerBgColor__6OPp8","wanderlustBg":"about_wanderlustBg__h0qgq","overLay":"about_overLay__HreHC"};